import React from 'react';

export const FormContext = React.createContext();

export const FormItemContext = React.createContext();
